import React from 'react';
import Header from 'components/Admin/shared/Table/Header.jsx';

const titles = {
  name: 'NAME',
  email: 'EMAIL',
  user_type: 'USER TYPE',
  county: 'COMPANY NAME',
  created_at: 'DATE REGISTERED',
  last_login: 'LAST LOGIN',
  logins: '#LOGINS'
};

const miniLabel = {
  first_name: 'First name',
  last_name: 'Last name',
};

const additionalProps = {
  created_at: {
    revert: true,
  },
  last_login: {
    revert: true
  },
  logins: {
    thProps: {
      colSpan: '2'
    },
    disabled: true
  },
  name: {
    values: ['first_name', 'last_name'],
    miniLabels: miniLabel
  }
};

function Headers({
                   onChange,
                   value: selectedValue,
                 }) {
  return (
    <tr>
      <th></th>
      {Object.keys(titles).map(value => (
        <Header
          onChange={onChange}
          key={value}
          values={[value]}
          title={titles[value]}
          selected={selectedValue}
          {...(additionalProps[value]) || {}}
        />
      ))}
    </tr>
  );
}

Headers.defaultProps = {};

Headers.propTypes = {};

export default Headers;



// WEBPACK FOOTER //
// ./src/components/Admin/UserSponsor/List/Headers.jsx